import { render, staticRenderFns } from "./form_pedido.vue?vue&type=template&id=3c9000fb"
import script from "./form_pedido.vue?vue&type=script&lang=js"
export * from "./form_pedido.vue?vue&type=script&lang=js"
import style0 from "./form_pedido.vue?vue&type=style&index=0&id=3c9000fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports